import { newPostFunction } from '@src/service'
import { ContactSupportRequest } from '@logic'
import { contactSupportUrl } from './urls'

export const requestNewFeature = newPostFunction<{}, ContactSupportRequest, {}>(contactSupportUrl)
